(function ($) {
	/* ---------------------------------------
		ハンバーガーメニュー
	--------------------------------------- */
	$('.nav_btn').on('click', function () {
		$(this).toggleClass('active');
		$('body').toggleClass('gnav_open');
	});
	$('.cover,.nav_global_wrap a').on('click', function () {
		if ($('body').hasClass('gnav_open')) {
			$('body').removeClass('gnav_open');
			$('.nav_btn').removeClass('active');
		}
	});

	/* ---------------------------------------
		ページトップ
	--------------------------------------- */
	$(function () {
		var page_top = $('.page_top');
		page_top.click(function () {
			$('body, html').animate({ scrollTop: 0 }, 500);
			return false;
		});
		$(window).scroll(function () {
			if ($(this).scrollTop() >= 2000) {
				page_top.fadeIn();
			} else {
				page_top.fadeOut();
			}
		});
	});

	/* ---------------------------------------
		未翻訳言語のナビを非表示
	--------------------------------------- */
	$('.bogo-language-switcher li').each(function () {
		if (!$('a', this)[0] && !$(this).hasClass('current')) {
			$(this).hide();
		}
	});

	/* ---------------------------------------
		object fit ie
	--------------------------------------- */
	objectFitImages('.objectfit img, .img_trim img');

	/* ---------------------------------------
		ページ遷移時にフェードイン・アウト
	--------------------------------------- */
	$(window).on('load', function () {
		$('body').removeClass('fadeout');
	});

	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);